import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from "./components/header/header.component";
import { MatSidenavModule } from "@angular/material/sidenav";
import { NavigationService, NavigationState } from './services/navigation.service';
import { AuthService } from './services/auth.service';
import { combineLatest, Observable } from 'rxjs';
import { User } from '@angular/fire/auth';


@Component({
  selector: 'app-root',
  imports: [RouterModule, HeaderComponent, MatSidenavModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'aia-poc';
  isOpen = false;

  private previousUser: User | null = null;

  constructor(
    private authService: AuthService,
    private navigationService: NavigationService
  ) {
    // listen to navigation state changes
    combineLatest([this.authService.user$, this.navigationService.state$])
      .subscribe(([user, state]: [User | null, NavigationState]) => {
      if (this.previousUser == null && user != null) {
      this.previousUser = user;
        this.navigationService.openNavigation();
      } else {
        this.previousUser = user;
        this.isOpen = state === NavigationState.Open && !!user;
      }
      console.log('Navigation state changed:', this.isOpen);
    }
    );
  }
}
